
// convert date in to month day and year
const formatDate = (date: any) => {
    const d = new Date(date);
    if (d instanceof Date && !isNaN(d.getTime()) && date !== "") {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [month, day, year].join('/');
    }
    else {
        return null
    }
}

export default formatDate;


// WEBPACK FOOTER //
// ./src/helpers/dateFormat.ts